import React from 'react';
import MainScreen from './Components/MainScreen/MainScreen';
import { enGB, registerTranslation } from 'react-native-paper-dates';

// Register the translation for the Date and time picker.
registerTranslation('en-GB', enGB);

/**
 * Application Entrypoint.
 */
export default function App(): JSX.Element
{
  return <MainScreen />;
}
